import{__assign as e}from"../../node_modules/tslib/tslib.es6.js";import r from"react";var t=function(t){var o=t.children,i=t.style;return r.createElement("div",{className:"storyblok-image-wrapper",style:e({position:"relative",overflow:"hidden"},i)},o)};export{t as Wrapper};
//# sourceMappingURL=Wrapper.js.map
